import { Link } from 'react-router-dom';
import { TableCell } from '@mui/material';
import { icons } from '@shared/static/icons';

//todo: подставить значения из row

export default function BalanceDetailsCell({ row }) {
  const firstString = (() => {
    switch (row.type) {
      case 0:
        return '-'; //Номер кошелька с которого закинули деньги
      case 'withdraw':
        return '-'; //Номер кошелька на который мы выводим деньги (мой кошелек из width channels)
      case 'transfer':
        return 'Internal transfer';
      default:
        return '';
    }
  })();

  const secondString = (() => {
    switch (row.type) {
      case 0:
        return '-'; //Ccылка на блокчейн транзакцию
      case 'withdraw':
        return '-'; //Ccылка на блокчейн транзакцию
      default:
        return '';
    }
  })();

  return (
    <TableCell>
      <div>
        <p>{firstString}</p>
        {/* <Link to="/transactions" className="dashed-btn">
          {secondString} {icons['tab-link']}
        </Link> */}
      </div>
    </TableCell>
  );
}
